import { fetchHelper } from '../../api/api'
import { plansActions } from './plansSlice'
import { processPlans } from './planUtils'
import { UserTypes } from '../../util/constants'

export async function fetchPlan(planId) {
    const response = await fetchHelper.get(`Subscriptionplan/${planId}`)
    return response.data
}

const getPlans = ({ type = UserTypes.Personal } = {}) => async dispatch => {
    try {
        dispatch(plansActions.getPlansRequest())
        const response = await fetchHelper.get('Subscriptionplan')
        const plans = processPlans(response.data, type)
        dispatch(plansActions.getPlansRequestSuccess({ plans }))
    } catch (error) {
        if (process.env.NODE_ENV === 'development') console.warn(error)
        dispatch(plansActions.getPlansRequestFailure(error.message))
    }
}

export const plansApi = {
    getPlans,
}
